import React, { useRef, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { debounce } from 'lodash-es';
import QuickSearchResult from './QuickSearchResult';
import { uniqueId } from 'lodash';
import { translate } from '../../Services/translation';
import { addOverlay, removeOverlay } from '../../Actions/Overlay.action';
import {
  query,
  setSearchQuery,
  handleKeyDown,
  toggleInputActive,
} from '../../Actions/QuickSearch.action';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import {
  QuickSearchWrapper,
  QuickSearchInput,
  QuickSearchIcon,
} from './styles/QuickSearch.styling';
import { QuickSearchModel } from '../../Types/QuickSearchModel';
import { setLoginModalOpen } from '../../Actions/Login.action';

const debouncedQuery = debounce(
  (dispatch, text) => dispatch(query(text)),
  200
);

// const QuickSearch = (props: { model: QuickSearchModel, forScreen: string }) => {
//   const quickSearch = useTypedSelector((state) => state.quickSearch);
//   const {
//     query,
//     result,
//     showResult,
//     activeTab,
//     inputActive,
//   } = quickSearch;

const QuickSearch = (props: QuickSearchModel) => {
  const quickSearch = useTypedSelector((state) => state.quickSearch);
  const {
    query,
    result,
    showResult,
    inputActive,
  } = quickSearch;

  const [id] = useState(uniqueId());
  const searchContainer = useRef(null);
  const searchInput = useRef<HTMLInputElement | null>(null);
  const dispatch = useDispatch();
  let searchUrl =
    global['LitiumQuickSearchUrl'] +
    (query.length > 0 ? `?q=${query}` : '');

  if (result?.brandSearchUrl) {
    searchUrl = result?.brandSearchUrl
  }

  useEffect(() => {
    if (inputActive) {
      searchInput.current?.focus();

      dispatch(
        addOverlay('quick-search__' + id, () =>
          dispatch(toggleInputActive(false))
        )
      );
    } else {
      dispatch(removeOverlay('quick-search__' + id));
    }
  }, [dispatch, inputActive, id]);
  return (
    <QuickSearchWrapper
      className="flex-grow"
      role="search"
      ref={searchContainer}
    >
      <div
        className="quick-search__form d-flex align-center lg:relative"
        role="search"
      >
        <div className="quick-search__input-section">
          <div className="quick-search__input-wrapper d-flex">
            <QuickSearchIcon
              // name={inputActive ? 'close' : (props.forScreen === "desktop" ? 'magnifier' : 'magnifying-glass')}
              name={inputActive ? 'close' : 'magnifying-glass'}
              $inputActive={inputActive}
              onClick={() =>
                dispatch(toggleInputActive(!inputActive, inputActive))
              }
            />
            <QuickSearchInput
              $inputActive={inputActive}
              type="search"
              enterKeyHint='search'
              placeholder={translate('general.search')}
              autoComplete="off"
              value={decodeURIComponent(query)}
              onChange={(event) => {
                const text = encodeURIComponent(event.target.value);
                dispatch(setSearchQuery(text));
                debouncedQuery(dispatch, text);
              }}
              onClick={() => {
                dispatch(toggleInputActive(true));
                dispatch(setLoginModalOpen(false));
              }}
              onKeyDown={(event) =>
                dispatch(handleKeyDown(event, { searchUrl }))
              }
              ref={searchInput}
            />
          </div>
        </div>
        {showResult && inputActive && result && (
          <QuickSearchResult
            result={result}
            searchUrl={searchUrl}
            // noHitDescription={props.model.noHitDescription}
            noHitDescription={props.noHitDescription}
            // noHitHeader={props.model.noHitHeader}
            noHitHeader={props.noHitHeader}
          />
        )}
      </div>
    </QuickSearchWrapper>
  );
};

export default QuickSearch;
